import { useContext } from "react";
import { TokenContext } from "../context/TokenContext";
import useSWR from "swr";
import { environment } from "../config/environment";
import { swrFetcher } from "../services/queries";
import { UserModel } from "@attelas/shared";

export const useUsers = () => {
  const { token } = useContext(TokenContext);

  const { data, isLoading, error } = useSWR<{ users: UserModel[] }>(`${environment.apiUrl}/api/users`, (url: string) =>
    swrFetcher(url, { headers: { Authorization: `Bearer ${token}` } })
  );

  return {
    users: data?.users ?? [],
    isLoading,
    isError: !!error,
  };
};
